@if (!mobile.isMobile && !hidden()) {
  <nav class="rpg-panel">
    <a
      class="rpg-item"
      [class.active]="isCurrentRoute('/')"
      (click)="navigateTo('/')"
    >Home</a>
    <a
      class="rpg-item"
      [class.active]="isCurrentRoute('/teams')"
      (click)="navigateTo('/teams')"
    >Teams</a>
    <a
      class="rpg-item"
      [class.active]="isSectionActive('/wiki')"
      (click)="navigateTo('/wiki')"
    >Wiki</a>
    <a
      class="rpg-item"
      [class.active]="isCurrentRoute('/leaderboard')"
      (click)="navigateTo('/leaderboard')"
    >Leaderboard</a>
    <a
      class="rpg-item"
      [class.active]="isCurrentRoute('/stats')"
      (click)="navigateTo('/stats')"
    >Stats</a>
    <a
      class="rpg-item gacha"
      [class.active]="gachaModal.showModal()"
      (click)="openGachaModal()"
    ><span class="gacha-icon">☀</span> Gacha</a>
  </nav>
}

@if (mobile.isMobile && !hidden()) {
  <nav class="mobile-bottom-bar">
    <a
      class="mobile-bottom-item"
      [class.active]="isCurrentRoute('/')"
      (click)="navigateTo('/')"
    >Home</a>
    <a
      class="mobile-bottom-item"
      [class.active]="isCurrentRoute('/teams')"
      (click)="navigateTo('/teams')"
    >Teams</a>
    <a
      class="mobile-bottom-item"
      [class.active]="isSectionActive('/wiki')"
      (click)="navigateTo('/wiki')"
    >Wiki</a>
    <a
      class="mobile-bottom-item gacha"
      [class.active]="gachaModal.showModal()"
      (click)="openGachaModal()"
    ><span class="gacha-icon">☀</span> Gacha</a>
    <a
      class="mobile-bottom-item settings-item"
      [class.active]="isCurrentRoute('/settings')"
      (click)="navigateTo('/settings')"
    ><app-pixel-creature [addr]="wallet.activeAddress() ?? ''" [size]="12" /> Settings</a>
    <a
      class="mobile-bottom-item mobile-bottom-social"
      href="https://x.com/stompdotgg"
      target="_blank"
      rel="noopener"
      title="Follow @stompdotgg on X"
      aria-label="Follow @stompdotgg on X"
    >
      <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    </a>
    <a
      class="mobile-bottom-item mobile-bottom-social"
      href="https://t.me/+U-BfjoNh5j9lZmUx"
      target="_blank"
      rel="noopener"
      title="Join the Telegram group"
      aria-label="Join the Telegram group"
    >
      <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.626 0 12 0zm5.568 8.16c-.169 1.858-.896 6.728-1.246 8.784-.148.869-.44 1.161-.72 1.19-.606.056-1.069-.4-1.656-.784-.92-.6-1.439-.974-2.331-1.561-1.032-.677-.363-1.048.225-1.658.154-.16 2.827-2.593 2.879-2.815.007-.027.013-.128-.049-.184-.061-.056-.152-.037-.216-.022-.092.022-1.556 1.028-4.393 3.019-.415.286-.792.424-1.131.417-.372-.008-1.09-.21-1.621-.385-.653-.214-1.172-.327-1.126-.691.024-.189.285-.382.781-.579 3.062-1.335 5.104-2.215 6.125-2.64 2.917-1.214 3.522-1.424 3.917-1.432.087-.002.281.02.408.122.073.054.124.162.149.29.013.085.029.279-.002.471z"/>
      </svg>
    </a>
  </nav>
}

@defer (on idle) {
  @if (gachaModal.showModal()) {
    <div class="modal-overlay" (click)="closeGachaModal()">
      <div class="modal-shell modal-shell--wide" (click)="$event.stopPropagation()">
        <app-gacha-roll
          mode="regular"
          (closed)="closeGachaModal()"
        />
      </div>
    </div>
  }
}
